export const pt_br = {
  validation_error: 'Este campo es obligatorio.',
  all: 'Todos',
  filter_result_text: 'MOSTRANDO',
  filter_msg_title: 'No se han encontrado resultados.',
  filter_msg: 'No pudimos encontrar lo que buscas. Intenta buscar de nuevo.',
  read_more: 'Ver mais',
  read_less: 'Ver menos',
};
